export const LicenseCreationAttributesMockData = {
  id: '1234',
  maxNumberOfLicensesPerMonth: 123,
  maxNumberOfLicensesInCurrentMonth: 2,
  maxLicensesPeriodInDays: 10,
  maximumLicenseDueDate: '2023-06-14T00:00:00-04:00',
  allowedDevices: ['SGTD', 'GLC'],
  userId: 'TODO user id',
  scopeId: 'todo',
  needsSignOff: false,
  canCreateUnlimitedLicense: false,
} as any;
